"use client"

import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import Logo from "./Logo"

const Footer = () => {
  const { t } = useTranslation("Footer")
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const productLinks = [
    { href: "/app", label: mounted ? t("startLearning") || "Start Learning" : "Start Learning" },
    { href: "/about", label: mounted ? t("about") : "About Roset" },
    { href: "/contact", label: mounted ? t("contact") : "Contact" },
  ]

  const legalLinks = [
    { href: "/terms", label: mounted ? t("terms") : "Terms of Service" },
    { href: "/privacy", label: mounted ? t("privacy") : "Privacy Policy" },
  ]

  return (
    <footer className="bg-slate-950 text-slate-400">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <Logo />
              <span className="text-lg font-semibold text-white">Roset</span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs">
              Practice languages with AI-powered voice conversations. 14 languages, available 24/7.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-semibold text-slate-300 uppercase tracking-wider mb-4">Product</h4>
            <ul className="space-y-2.5">
              {productLinks.map((link, idx) => (
                <li key={idx}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors duration-150">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold text-slate-300 uppercase tracking-wider mb-4">Legal</h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link, idx) => (
                <li key={idx}>
                  <a href={link.href} className="text-sm hover:text-white transition-colors duration-150">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            {mounted ? t("copyright") : "\u00A9 2025 Roset. All rights reserved."}
          </p>
          <div className="flex items-center gap-5">
            <a
              href="https://wa.me/+4552803868"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-slate-500 hover:text-white transition-colors duration-150"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
